<template>
  <div class="bank-info">
    <p class="text">
      {{ $t('bankInfo.withdrawalAmount') }} <span class="value">${{ state.withdrawalAmount }}</span>
    </p>
    <p class="text">{{ $t('bankInfo.bankCharges') }} <span class="value">{{ $t('fawry.bankCharges') }}</span></p>
    <p class="text" v-if="state.withdrawalStatus">
      {{ $t('withdraw.reviewStatus') }} <span class="value">{{ state.withdrawalStatus }}</span>
    </p>
    <p class="text">{{ $t('bankInfo.accountInfo') }}</p>
    <div class="information">
      <x-table>
        <tr class="row">
          <td class="col">{{ $t('fawry.phoneNumber') }}</td>
          <td class="col col-value">{{ bankInfo.payee_account_no }}</td>
        </tr>
        <tr class="row">
          <td class="col">{{ $t('bankInfo.yourName') }}</td>
          <td class="col col-value">{{ bankInfo.payee_name }}</td>
        </tr>
        <tr class="row">
          <td class="col">{{ $t('bankInfo.signature') }}</td>
          <td class="col col-value"><img :src="bankInfo.signature" alt srcset /></td>
        </tr>
      </x-table>
    </div>
  </div>
</template>
<script>
import { XTable } from 'vux'
import state from '@/state.js'
import { CURRENCY_MAP, CODE_LABEL_MAP } from '@/utils/constants'
export default {

  components: {
    XTable
  },
  data() {
    return {
      state
    }
  },
  computed: {
    bankInfo() {
      return this.state.bankInfo
    },
    currency() {
      return CURRENCY_MAP[this.state.country]
    },
    codeLabel() {
      return CODE_LABEL_MAP[this.state.country]
    }
  }
}
</script>
<style lang="scss">
.bank-info {
  .text {
    margin-bottom: 13px;

    color: #3c3c43;

    .value {
      padding-left: 12px;

      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      vertical-align: middle;

      color: #BA30F5;
    }
  }

  .information {
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 8px;

    background: #fff;
  }

  .vux-table:after {
    display: none;
  }

  .row:last-child td:before {
    display: none;
  }

  .col {
    padding: 17px 16px;
    width: 50%;

    line-height: 19px;

    color: #3c3c43;
  }

  .col-value {
    font-weight: 600;
    text-align: left;
  }
}
</style>
